/**
 * Wire browser online/offline events to React Query's onlineManager.
 * Import once at app bootstrap (via queryClient.js).
 */

import { onlineManager } from '@tanstack/react-query';
import logger from '../Utils/logger';

let isSetup = false;

export const setupOnlineManager = () => {
  if (isSetup || typeof window === 'undefined') return;
  isSetup = true;

  onlineManager.setEventListener((setOnline) => {
    const handleOnline = () => {
      logger.info('Network: online — React Query will resume paused requests');
      setOnline(true);
    };

    const handleOffline = () => {
      logger.warn('Network: offline — React Query will pause networkMode:online work');
      setOnline(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Sync initial state (e.g. app opened while offline)
    setOnline(navigator.onLine);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  });
};

export default setupOnlineManager;
